import type { PrincipalRole } from "~/domain/types";
/* Re-exported under the name eight consumers already import. The literals
 * live in one place so the product-boundary gate has one file to exempt. */
export { HARVEST_NAV_TITLES as FORBIDDEN_MAIN_TITLES } from "~/domain/harvest-denylist";

export type MainNavId = "inbox" | "domains" | "mailboxes";

export interface MainNavItem {
  id: MainNavId;
  title: string;
  href: string;
  group: "mail" | "infrastructure";
}

export interface UserMenuItem {
  id: string;
  title: string;
  href: string;
}

const MAIN: readonly MainNavItem[] = [
  { id: "inbox", title: "Inbox", href: "/mail", group: "mail" },
  { id: "domains", title: "Domains", href: "/domains", group: "infrastructure" },
  { id: "mailboxes", title: "Mailboxes", href: "/mailboxes", group: "infrastructure" },
];

const SETTINGS_ITEMS: readonly UserMenuItem[] = [
  { id: "general", title: "Settings", href: "/settings" },
  { id: "team", title: "Team", href: "/settings/team" },
  { id: "keys", title: "API keys", href: "/settings/api-keys" },
  { id: "security", title: "Security", href: "/settings/security" },
];

/**
 * Sidebar Main: Inbox always; Domains and Mailboxes for people who provision.
 *
 * Members with only mailbox grants see Inbox. This install is single-tenant and
 * the operator is owner — tests pin the three-item list for owner.
 */
export function mainNavFor(role: PrincipalRole): readonly MainNavItem[] {
  if (role === "member" || role === "auditor") {
    return MAIN.filter((item) => item.id === "inbox");
  }
  return MAIN;
}

export function userMenuFor(role: PrincipalRole): readonly UserMenuItem[] {
  const items: UserMenuItem[] = [...SETTINGS_ITEMS, { id: "help", title: "Help", href: "/help" }];
  if (role === "owner") {
    items.splice(4, 0, { id: "operations", title: "Operations", href: "/settings/operations" });
  }
  return items;
}

export function isMainNavActive(href: string, pathname: string): boolean {
  if (href === "/mail") return pathname === "/mail" || pathname.startsWith("/mail/");
  return pathname === href || pathname.startsWith(`${href}/`);
}

